/* Background pumpkin (replaces the globe): a big glowing jack-o'-lantern fixed behind the page.
   Pure canvas (no libraries). Sways slightly and the face flickers; static when "reduce motion" is on;
   paused when the tab is hidden. To remove: delete the yt-globe.js script tag in layout/theme.liquid. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cv, ctx, D = 0, dpr = 1, last = 0;

  function size() {
    var vw = window.innerWidth, vh = window.innerHeight;
    D = vw < 700 ? Math.max(vw * 1.5, 520) : Math.min(vw * 0.62, vh * 1.35);
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = cv.height = Math.round(D * dpr);
    cv.style.width = cv.style.height = D + 'px';
    cv.style.left = (vw < 700 ? (vw - D) / 2 : vw - D * 0.86) + 'px';
    cv.style.top = (vh * 0.5 - D / 2 + (vw < 700 ? vh * 0.12 : 0)) + 'px';
    draw(0);
  }

  function poly(pts) {
    ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]);
    for (var i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
    ctx.closePath();
  }

  function draw(t) {
    var W = cv.width, c = W / 2, R = W * 0.46, H = W * 0.36, cy = c + W * 0.07;
    ctx.clearRect(0, 0, W, W);
    var sway = reduce ? 0 : Math.sin(t / 2600) * 0.03;
    ctx.save(); ctx.translate(c, cy + H); ctx.rotate(sway); ctx.translate(-c, -(cy + H));

    // outer glow
    ctx.save(); ctx.shadowColor = 'rgba(255,106,0,.55)'; ctx.shadowBlur = W * 0.08;
    ctx.fillStyle = 'rgba(200,70,0,.5)'; ctx.beginPath(); ctx.ellipse(c, cy, R * 0.9, H * 0.9, 0, 0, 7); ctx.fill(); ctx.restore();

    // ribs: outer lobes first, centre lobe last
    var lobes = [[-0.62, 0.42, 0.86], [0.62, 0.42, 0.86], [-0.31, 0.46, 0.96], [0.31, 0.46, 0.96], [0, 0.48, 1]];
    lobes.forEach(function (l) {
      var x = c + l[0] * R, rx = l[1] * R, ry = l[2] * H;
      var g = ctx.createLinearGradient(x - rx, 0, x + rx, 0);
      g.addColorStop(0, '#7a2a00'); g.addColorStop(0.45, '#ff8a1c'); g.addColorStop(0.6, '#f26a00'); g.addColorStop(1, '#6a2200');
      ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(x, cy, rx, ry, 0, 0, 7); ctx.fill();
      ctx.strokeStyle = 'rgba(70,20,0,.7)'; ctx.lineWidth = Math.max(1.5, W / 420); ctx.stroke();
    });

    // stem
    var sx = c, sy = cy - H * 0.98;
    ctx.fillStyle = '#3b2a10'; ctx.strokeStyle = '#1c1306'; ctx.lineWidth = Math.max(1.5, W / 420);
    poly([[sx - W * 0.05, sy + W * 0.02], [sx - W * 0.03, sy - W * 0.08], [sx + W * 0.01, sy - W * 0.13], [sx + W * 0.06, sy - W * 0.11],
          [sx + W * 0.035, sy - W * 0.06], [sx + W * 0.05, sy + W * 0.02]]);
    ctx.fill(); ctx.stroke();

    // face: glowing, flickering
    var fl = reduce ? 0.85 : 0.8 + 0.2 * Math.sin(t / 130) * Math.sin(t / 370 + 1);
    ctx.save(); ctx.shadowColor = 'rgba(255,200,40,' + fl + ')'; ctx.shadowBlur = W * 0.05;
    ctx.fillStyle = 'rgba(255,' + Math.round(190 + 40 * fl) + ',40,' + (0.75 + 0.25 * fl) + ')';
    var u = W * 0.01;
    poly([[c - 27 * u, cy - 8 * u], [c - 10 * u, cy - 8 * u], [c - 18 * u, cy - 24 * u]]); ctx.fill();
    poly([[c + 10 * u, cy - 8 * u], [c + 27 * u, cy - 8 * u], [c + 18 * u, cy - 24 * u]]); ctx.fill();
    poly([[c - 4 * u, cy + 1 * u], [c + 4 * u, cy + 1 * u], [c, cy - 6 * u]]); ctx.fill();
    poly([[c - 30 * u, cy + 8 * u], [c - 20 * u, cy + 14 * u], [c - 14 * u, cy + 10 * u], [c - 7 * u, cy + 17 * u], [c, cy + 11 * u],
          [c + 7 * u, cy + 17 * u], [c + 14 * u, cy + 10 * u], [c + 20 * u, cy + 14 * u], [c + 30 * u, cy + 8 * u],
          [c + 22 * u, cy + 27 * u], [c + 10 * u, cy + 22 * u], [c, cy + 29 * u], [c - 10 * u, cy + 22 * u], [c - 22 * u, cy + 27 * u]]);
    ctx.fill(); ctx.restore();
    ctx.restore();
  }

  function tick(t) {
    requestAnimationFrame(tick);
    if (document.hidden || t - last < 33) return;
    last = t; draw(t);
  }

  document.addEventListener('DOMContentLoaded', function () {
    cv = document.createElement('canvas'); cv.className = 'yt-globe'; cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;z-index:-1;pointer-events:none;transform:rotate(-8deg);opacity:.88';
    document.body.insertBefore(cv, document.body.firstChild);
    ctx = cv.getContext('2d'); if (!ctx) return;
    size(); window.addEventListener('resize', size);
    if (!reduce) requestAnimationFrame(tick);
  });
})();
